module.exports = __webpack_public_path__ + "fonts/Inter-600-cyrillic37.de93fdc.woff2";